import instance from 'axiosInstance';

export const authorizationQueryFunc = async () => {
  const response = await instance.get('/private/refresh-user-details');

  return response.data;
};
